/* Existing native contact forms: no field values or POST behavior are changed. */
(function () {
  'use strict';
  if (window.__mgEnquiryTracking) return;
  window.__mgEnquiryTracking = true;
  var config = document.querySelector('script[data-mg-enquiry-tracking]');
  if (!config) return;
  var key = 'mg_enquiry_pending_v1';
  var measurement = 'G-LN6FQWGP2M';
  var ttl = 30 * 60 * 1000;
  function allowed() {
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function clear() { try { sessionStorage.removeItem(key); } catch (_) {} }
  function read() {
    try { return JSON.parse(sessionStorage.getItem(key) || 'null'); }
    catch (_) { return null; }
  }
  function language() {
    var lang = config.getAttribute('data-language');
    return ['en', 'zh-hant', 'zh-hans'].indexOf(lang) >= 0 ? lang : 'en';
  }
  function safeUrl(value) {
    try { var url = new URL(value, location.origin); return url.origin + url.pathname; }
    catch (_) { return ''; }
  }
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM' || !form.id) return;
    if (form.id === 'captcha_form') return; // Preserve the original contact-form nonce across Shopify verification.
    var type = form.querySelector('input[name="form_type"]');
    if (!type || type.value !== 'contact') return;
    clear();
    // Shopify's CAPTCHA can prevent the initial submit, then submit natively after validation.
    // Keeping a nonce is not a conversion; only Shopify's later success marker can consume it.
    if (!allowed() || !form.checkValidity()) return;
    try {
      var bytes = new Uint8Array(16);
      crypto.getRandomValues(bytes);
      var id = Array.prototype.map.call(bytes, function (b) { return b.toString(16).padStart(2, '0'); }).join('');
      sessionStorage.setItem(key, JSON.stringify({ id: id, form: form.id, at: Date.now(), language: language() }));
    } catch (_) { /* Tracking failure must never block the customer's message. */ }
  });
  function confirmed() {
    var pending = read();
    if (!pending) return;
    if (!allowed() || !/^[a-f0-9]{32}$/.test(pending.id || '') ||
        typeof pending.at !== 'number' || Date.now() - pending.at > ttl || Date.now() < pending.at) { clear(); return; }
    var markers = document.querySelectorAll('[data-mg-enquiry-sent]');
    // Recover a pending attempt made by the first draft while on Shopify's challenge page.
    if (pending.form === 'captcha_form' && ['#MgContactForm', '#ConciergeContactForm'].indexOf(location.hash) >= 0) {
      pending.form = location.hash.slice(1);
    }
    var matched = Array.prototype.some.call(markers, function (marker) {
      return marker.getAttribute('data-mg-enquiry-sent') === pending.form;
    });
    if (!matched) return;
    clear(); // Consume before dispatch: reloads and repeated initialization cannot count twice.
    var test = config.getAttribute('data-theme-role') !== 'main';
    window.dataLayer = window.dataLayer || [];
    var gtag = function () { window.dataLayer.push(arguments); };
    if (!document.querySelector('script[src^="https://www.googletagmanager.com/gtag/js"]')) {
      var script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + measurement;
      document.head.appendChild(script);
      gtag('js', new Date());
    }
    gtag('config', measurement, { send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: false });
    var params = {
      send_to: measurement,
      form_name: pending.form === 'MgContactForm' ? 'Store enquiry' : pending.form === 'ConciergeContactForm' ? 'Concierge enquiry' : 'Contact enquiry',
      language: ['en', 'zh-hant', 'zh-hans'].indexOf(pending.language) >= 0 ? pending.language : 'en',
      event_id: pending.id,
      page_location: safeUrl(location.href),
      page_referrer: document.referrer ? safeUrl(document.referrer) : ''
    };
    if (test) params.debug_mode = true;
    gtag('event', test ? 'memorigin_enquiry_test' : 'generate_lead', params);
  }
  function init() {
    if (allowed()) confirmed();
    else if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) confirmed();
      });
    }
  }
  document.addEventListener('visitorConsentCollected', function () { if (allowed()) confirmed(); else clear(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

